import { render } from "./LanguageConflictModal.vue?vue&type=template&id=48d4b244&scoped=true"
import script from "./LanguageConflictModal.vue?vue&type=script&lang=js"
export * from "./LanguageConflictModal.vue?vue&type=script&lang=js"

import "./LanguageConflictModal.vue?vue&type=style&index=0&id=48d4b244&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d4b244"]])

export default __exports__